import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateInsurance,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [leases, setLeases] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        ...select_data,
        vehicleId: select_data.vehicleId ? select_data.vehicleId._id : "",
        leaseId: select_data.leaseId ? select_data.leaseId._id : "",
        clientId: select_data.clientId ? select_data.clientId._id : "",

        Date: select_data.Date ? select_data.Date.split("T")[0] : "",
        DoneDate: select_data.DoneDate
          ? select_data.DoneDate.split("T")[0]
          : "",
        documenttypeId: select_data.documenttypeId._id,
        documentCopy: [...(select_data.documentCopy || [])],
      });
    }
  }, [select_data, documents]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  // const handleChange = (e) => {
  //   const { name, value, files } = e.target;
  //   if (name === "documentCopy") {
  //     setUpdate_modal_data({ ...update_modal_data, [name]: files });
  //   } else {
  //     setUpdate_modal_data({ ...update_modal_data, [name]: value });
  //   }
  // };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "vehicleId") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        vehicleId: { ...prevData.vehicleId, [name]: value },
      }));
    } else if (name === "leaseId") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        leaseId: { ...prevData.leaseId, [name]: value },
      }));
    } else if (name === "clientId") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        clientId: { ...prevData.clientId, [name]: value },
      }));
      // } else if (name === "documentCopy") {
      //   const selectedFiles = Array.from(files);

      //   setUpdate_modal_data((prev) => ({
      //     ...prev,
      //     documentCopy: [...prev.documentCopy, ...selectedFiles], // ✅ append only
      //   }));

      //   e.target.value = null; // ✅ allow reselect same file
      // }
    } else if (name === "documentCopy") {
      const selectedFiles = Array.from(files);

      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      const validFiles = selectedFiles.filter((file) =>
        allowedTypes.includes(file.type)
      );

      if (validFiles.length !== selectedFiles.length) {
        Swal.fire(
          "Invalid file type",
          "Only PDF, JPG, and PNG files are allowed",
          "error"
        );
        e.target.value = null;
        return;
      }

      setUpdate_modal_data((prev) => ({
        ...prev,
        documentCopy: [...prev.documentCopy, ...validFiles],
      }));

      e.target.value = null; // allow reselect same file
    } else {
      setUpdate_modal_data((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateFields = () => {
    const newErrors = {};
    return Object.keys(newErrors).length === 0;
  };
  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          const formData = new FormData();
          formData.append("documenttypeId", update_modal_data.documenttypeId);
          formData.append("Date", update_modal_data.Date);
          formData.append("DoneDate", update_modal_data.DoneDate);

          if (
            update_modal_data.amountPaid !== undefined &&
            update_modal_data.amountPaid !== null &&
            update_modal_data.amountPaid !== ""
          ) {
            formData.append("amountPaid", Number(update_modal_data.amountPaid));
          }

          formData.append("comments", update_modal_data.comments);
          formData.append("pocName", update_modal_data.pocName);
          formData.append("pocContact", update_modal_data.pocContact);
          formData.append("state", update_modal_data.state);

          // ✅ Always valid ObjectId
          if (update_modal_data.vehicleId) {
            formData.append("vehicleId", update_modal_data.vehicleId);
          }

          // ✅ FIX: Only append if NOT empty
          if (update_modal_data.leaseId && update_modal_data.leaseId !== "") {
            formData.append("leaseId", update_modal_data.leaseId);
          }

          // ✅ FIX: Only append if NOT empty
          if (update_modal_data.clientId && update_modal_data.clientId !== "") {
            formData.append("clientId", update_modal_data.clientId);
          }

          // ✅ Handle multiple document uploads correctly
          if (Array.isArray(update_modal_data.documentCopy)) {
            update_modal_data.documentCopy.forEach((file) => {
              if (file instanceof File) {
                formData.append("documentCopy", file);
              }
            });
          }

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/insurance/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateInsurance(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  // const handleUpdate = async () => {
  //   const token = localStorage.getItem("token");

  //   if (!validateFields()) {
  //     Swal.fire("Please fill in all required fields", "", "error");
  //     return;
  //   }

  //   Swal.fire({
  //     icon: "warning",
  //     title: "Are you sure you want to take this action?",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         const { _id } = update_modal_data;
  //         if (!_id) {
  //           throw new Error("ID is not defined");
  //         }

  //         // Create a new FormData object
  //         const formData = new FormData();
  //         formData.append("documenttypeId", update_modal_data.documenttypeId);
  //         formData.append("Date", update_modal_data.Date);
  //         formData.append("DoneDate", update_modal_data.DoneDate);
  //         // formData.append("amountPaid", update_modal_data.amountPaid);
  //         if (
  //           update_modal_data.amountPaid !== undefined &&
  //           update_modal_data.amountPaid !== null &&
  //           update_modal_data.amountPaid !== ""
  //         ) {
  //           formData.append("amountPaid", Number(update_modal_data.amountPaid));
  //         }

  //         formData.append("comments", update_modal_data.comments);
  //         formData.append("pocName", update_modal_data.pocName);
  //         formData.append("pocContact", update_modal_data.pocContact);
  //         formData.append("state", update_modal_data.state);
  //         formData.append("vehicleId", update_modal_data.vehicleId);
  //         formData.append("leaseId", update_modal_data.leaseId);
  //         formData.append("clientId", update_modal_data.clientId);

  //         // if (update_modal_data.documentCopy instanceof FileList) {
  //         //   formData.append("documentCopy", update_modal_data.documentCopy[0]);
  //         // } else if (update_modal_data.documentCopy instanceof File) {
  //         //   formData.append("documentCopy", update_modal_data.documentCopy);
  //         // }
  //         if (Array.isArray(update_modal_data.documentCopy)) {
  //           update_modal_data.documentCopy.forEach((file) => {
  //             if (file instanceof File) {
  //               formData.append("documentCopy", file);
  //             }
  //           });
  //         }

  //         const res = await axios.put(
  //           `${process.env.REACT_APP_BASE_URL}/api/insurance/${_id}`,
  //           formData,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //               "Content-Type": "multipart/form-data",
  //             },
  //           }
  //         );

  //         if (res.data.success) {
  //           Swal.fire("Update success", "", "success");
  //           onUpdateInsurance(update_modal_data);
  //           setRen(!ren);
  //         }
  //       } catch (error) {
  //         Swal.fire("Update failed", "", "error");
  //       }
  //       set_update_data_modal_Show(false);
  //     } else if (result.isDenied) {
  //       Swal.fire("Changes are not saved", "", "info");
  //     }
  //   });
  // };

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/document-type`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDocuments(response.data.types);
      } catch (error) {
        setDocuments([]);
      }
    };
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };
    const fetchLeases = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/leases`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLeases(response.data.leases);
      } catch (error) {
        console.error("Error fetching leases:", error);
        setLeases([]);
      }
    };
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      }
    };
    fetchVehicles(currentPage);
    fetchLeases(currentPage);
    fetchClients(currentPage);
    fetchDocuments(currentPage);
  }, [currentPage]);

  const handleDocumentChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      documenttypeId: value, // ✅ STRING ONLY
    }));
  };

  const handleVehicleChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      vehicleId: value,
    }));
  };
  const handleLeaseChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      leaseId: value,
    }));
  };
  const handleClientChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      clientId: value,
    }));
  };

  // const removeUpdateDocument = (index) => {
  //   setUpdate_modal_data((prev) => ({
  //     ...prev,
  //     documentCopy: prev.documentCopy.filter((_, i) => i !== index),
  //   }));
  // };
  const removeUpdateDocument = async (index) => {
    const token = localStorage.getItem("token");
    const doc = update_modal_data.documentCopy[index];

    // ✅ Already uploaded file
    if (!(doc instanceof File)) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BASE_URL}/api/insurance/${update_modal_data._id}/document`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              public_id: doc.public_id, // ✅ QUERY PARAM (IMPORTANT)
            },
          }
        );
      } catch (error) {
        Swal.fire("Failed to delete document", "", "error");
        return;
      }
    }

    // ✅ Remove from UI
    setUpdate_modal_data((prev) => ({
      ...prev,
      documentCopy: prev.documentCopy.filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Insurance Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Vehicle </Form.Label>
              <Form.Control
                as="select"
                name="vehicleId"
                value={update_modal_data.vehicleId || ""}
                onChange={handleVehicleChange}
                isInvalid={!!errors.vehicleId}
              >
                <option value="">Select Vehicle</option>
                {vehicles.map((vehicle) => (
                  <option key={vehicle._id} value={vehicle._id}>
                    {vehicle.numberplate}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Leasing Partner</Form.Label>
              <Form.Control
                as="select"
                name="leaseId"
                value={update_modal_data.leaseId || ""}
                onChange={handleLeaseChange}
                isInvalid={!!errors.leaseId}
              >
                <option value="">Select Leasing Partner</option>

                {Array.from(
                  new Map(
                    leases.map((lease) => [lease.leasing_partner, lease]) // ✅ unique by name
                  ).values()
                ).map((lease) => (
                  <option key={lease._id} value={lease._id}>
                    {lease.leasing_partner}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="">
              <Form.Label>Client </Form.Label>
              <Form.Control
                as="select"
                name="clientId"
                value={update_modal_data.clientId || ""}
                onChange={handleClientChange}
                isInvalid={!!errors.clientId}
              >
                <option value="">Select Client Name</option>
                {clients.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Document Type</Form.Label>
              <Form.Control
                as="select"
                name="documenttypeId"
                value={update_modal_data.documenttypeId || ""}
                onChange={handleDocumentChange}
                isInvalid={!!errors.documenttypeId}
              >
                <option value="">Select Document Type</option>
                {documents.map((type) => (
                  <option key={type._id} value={type._id}>
                    {type.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3" controlId="insuranceDate">
              <Form.Label>Document Due Date</Form.Label>
              <Form.Control
                type="date"
                name="Date"
                value={update_modal_data.Date || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="DoneDate">
              <Form.Label>Done Date</Form.Label>
              <Form.Control
                type="date"
                name="DoneDate"
                value={update_modal_data.DoneDate || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="amountPaid">
              <Form.Label>Amount Paid</Form.Label>
              <Form.Control
                type="number"
                name="amountPaid"
                value={update_modal_data.amountPaid || ""}
                onChange={handleChange}
                isInvalid={!!errors.amountPaid}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={update_modal_data.state || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>POC Name</Form.Label>
              <Form.Control
                type="text"
                name="pocName"
                value={update_modal_data.pocName || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>POC Contact</Form.Label>
              <Form.Control
                type="number"
                name="pocContact"
                value={update_modal_data.pocContact || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="comments">
              <Form.Label>Comments</Form.Label>
              <Form.Control
                type="text"
                name="comments"
                value={update_modal_data.comments || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Document Image</Form.Label>
              <Form.Control
                type="file"
                name="documentCopy"
                // accept="image/*"
                onChange={handleChange}
                accept=".pdf,image/*"
                multiple
              />
              {errors.documentCopy && (
                <small className="text-danger">{errors.documentCopy}</small>
              )}
            </Form.Group>

            {/* ✅ MULTI FILE PREVIEW */}
            {update_modal_data.documentCopy?.length > 0 && (
              <Form.Group className="mb-3">
                <Form.Label>Document Preview</Form.Label>

                {/* <div className="d-flex flex-wrap gap-2"> */}
                <div className="w-100 d-flex flex-column gap-2">
                  {/* ✅ FILE NAME PREVIEW (NO IMAGE PREVIEW) */}
                  {update_modal_data.documentCopy?.length > 0 && (
                    <Form.Group className="mb-3">
                      <Form.Label>Documents</Form.Label>

                      <div className="d-flex flex-column gap-2">
                        {update_modal_data.documentCopy.map((file, index) => {
                          const isNewFile = file instanceof File;

                          return (
                            <div
                              key={index}
                              className="d-flex align-items-center border rounded px-3 py-2 w-100"
                              style={{ background: "#f9f9f9" }}
                            >
                              {/* ✅ FILE NAME + STATUS (TAKES FULL REMAINING WIDTH) */}
                              <div className="d-flex flex-column flex-grow-1 min-w-0">
                                <span className="fw-semibold text-truncate d-block">
                                  {isNewFile
                                    ? file.name
                                    : decodeURIComponent(
                                        file.url
                                          .split("/")
                                          .pop()
                                          .split("-")
                                          .slice(1)
                                          .join("-")
                                      )}
                                </span>

                                <small
                                  className={
                                    isNewFile ? "text-success" : "text-primary"
                                  }
                                >
                                  {isNewFile ? "New" : "Uploaded"}
                                </small>
                              </div>

                              {/* ✅ REMOVE BUTTON (ALWAYS RIGHT) */}
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm ms-3 flex-shrink-0"
                                onClick={() => removeUpdateDocument(index)}
                              >
                                ✕
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </Form.Group>
                  )}
                </div>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
